import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ChangeValue } from "@similarweb/ui-components";

import { Marker } from "../../common/Marker";

export const TooltipRightData = styled.div`
    display: flex;
    flex-direction: column;
    text-align: right;
`;

export const TooltipValue = styled.p`
    margin: 0;
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;

export const CenteredWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const ChartContainer = styled.div`
    margin: 8px 16px 16px;
`;

export const NoDataTooltipValue = styled.p`
    margin: 0;
    padding: 0;
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;

export const StyledChangeValue = styled(ChangeValue)`
    & .ChangeValue-text {
        font-weight: 500;
    }
`;

export const StyledMarker = styled(Marker)`
    height: 16px;
    width: 16px;
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;
